import { render } from "./App.vue?vue&type=template&id=ac6836fe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ac6836fe&lang=scss"
script.render = render

export default script